module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0067.png.cd6ad902.jpg";